'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
// @ts-nocheck
exports.default = {
    exceptOnlyVendorIDs: ['699027a3-1086-46f5-9dcc-add51ca2518e']
};